import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import { Coins } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { toast } from "sonner";

const PRESETS = [1, 5, 10, 50];

export function TipModal({ open, onClose, recipient, songId, onDone }) {
  const [amount, setAmount] = useState(5);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  if (!recipient) return null;
  const fee = 0;
  const send = async () => {
    setLoading(true);
    try {
      await api.post("/tips", { recipient_id: recipient.id, amount: Number(amount), message, song_id: songId || null });
      toast.success(`Tipped $${Number(amount).toFixed(2)} to ${recipient.display_name} 🎉`);
      onDone?.();
      onClose();
    } catch (e) { toast.error(errMsg(e)); }
    setLoading(false);
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="jx-glass border-white/10" data-testid="tip-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Coins className="text-purple-400" size={20} /> Tip {recipient.display_name}</DialogTitle>
        </DialogHeader>
        <p className="text-xs text-slate-400 -mt-2">Tips are sent instantly from your JixxeoX wallet balance.</p>
        <div className="grid grid-cols-4 gap-2">
          {PRESETS.map((p) => (
            <button key={p} data-testid={`tip-preset-${p}`} onClick={() => setAmount(p)}
              className={`py-2.5 rounded-xl font-semibold text-sm border transition-colors ${Number(amount) === p ? "jx-cta text-white border-transparent" : "border-white/10 text-slate-300 hover:border-purple-500/40"}`}>
              ${p}
            </button>
          ))}
        </div>
        <Input type="number" min="0.5" step="0.5" value={amount} onChange={(e) => setAmount(e.target.value)}
          placeholder="Custom amount" data-testid="tip-amount-input" className="bg-black/30 border-white/10" />
        <Textarea value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Add a message (optional)"
          data-testid="tip-message-input" className="bg-black/30 border-white/10" />
        <div className="text-xs text-slate-400 flex justify-between">
          <span>Fee</span><span>${fee.toFixed(2)}</span>
        </div>
        <button onClick={send} disabled={loading || Number(amount) <= 0} data-testid="tip-send-btn"
          className="jx-cta text-white font-semibold py-3 rounded-xl disabled:opacity-50">
          {loading ? "Sending…" : `Send $${Number(amount || 0).toFixed(2)} Tip`}
        </button>
      </DialogContent>
    </Dialog>
  );
}
